export const en = {
  nav: {
    home: 'HOME',
    rsvp: 'RSVP',
    details: 'DETAILS',
    gallery: 'GALLERY',
    travel: 'TRAVEL',
    dressCode: 'DRESS CODE'
  },
  home: {
    invitation: 'INVITING YOU TO\nJOIN US AS WE\nTIE THE KNOT',
    coupleNames: 'POLINA & EVGENIY',
    date: '07.09.2026',
    dateRange: 'September 6-8, 2026',
    location: 'Talici Hill, Montenegro',
    locationLabel: 'LOCATION',
    venueName: 'Talici Hill',
    venueLocation: 'Montenegro',
    countdown: 'Time until ceremony',
    days: 'DAYS',
    hours: 'HOURS',
    minutes: 'MINUTES',
    seconds: 'SECONDS',
    rsvpButton: 'RSVP Form',
    rsvpSubtext: 'Let us know if you can join us',
    addToCalendar: 'Add to Calendar'
  },
  rsvp: {
    title: 'RSVP to Our Wedding',
    subtitle: 'Please let us know if you can join us for our special day',
    guestInfo: 'Guest Information',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email Address',
    phone: 'Phone Number',
    attendance: 'Will you be attending?',
    attendingYes: 'Joyfully Accept',
    attendingNo: 'Regretfully Decline',
    whichDays: 'Which days will you be attending?',
    day1: 'September 6 (Welcome Dinner)',
    day2: 'September 7 (Wedding Day)',
    day3: 'September 8 (Farewell Brunch)',
    selectOneDay: '* Please select at least one day',
    addGuest: '+ Add Guest',
    addGuestNote: 'Click to add additional guests to your RSVP',
    guestNumber: 'Guest',
    information: 'Information',
    remove: 'Remove',
    bringingKids: 'I am bringing kids',
    numberOfKids: 'Number of kids',
    dietary: 'Additional Dietary Restrictions',
    dietaryNone: 'None',
    dietaryVegetarian: 'Vegetarian',
    dietaryVegan: 'Vegan',
    dietaryGlutenFree: 'Gluten-Free',
    dietaryOther: 'Other',
    dietaryDetails: 'Please specify your dietary needs',
    message: 'Message to the Couple',
    submit: 'Submit RSVP',
    submitting: 'Submitting...',
    thankYou: 'Thank You!',
    successMessage: 'Your information has been successfully submitted.',
    successMessage2: 'We\'ve received your RSVP and can\'t wait to celebrate with you!',
    confirmationEmail: 'You\'ll receive a confirmation at the email address you provided.'
  },
  schedule: {
    title: 'Three Days of Celebration',
    subtitle: 'Join us for a magical weekend in Montenegro',
    day1Title: 'Welcome Dinner',
    day2Title: 'Wedding Ceremony',
    day3Title: 'Farewell Brunch',
    time: 'Time',
    location: 'Location',
    dates: {
      day1: '6th September',
      day2: '7th September',
      day3: '8th September'
    },
    events: {
      day1: {
        event1: {
          title: 'Arrival at Venue',
          description: 'Welcome to Talici Hill! Please arrive and check in at the venue.',
          location: 'Talici Hill Reception'
        },
        event2: {
          title: 'Welcome Dinner Begins',
          description: 'Join us for a delightful welcome dinner to kick off our celebration.',
          location: 'Talici Hill Garden'
        },
        event3: {
          title: 'End of Welcome Dinner',
          description: 'Conclude the evening and rest up for the big day ahead.',
          location: 'Talici Hill Garden'
        }
      },
      day2: {
        event1: {
          title: 'Welcome Drinks At Villa',
          description: 'Gather for pre-ceremony drinks and mingle with fellow guests.',
          location: 'Talici Hill Reception'
        },
        event2: {
          title: 'Photoshoots',
          description: 'Professional photography session with the couple and wedding party.',
          location: 'Ceremony Garden'
        },
        event3: {
          title: 'Ceremony',
          description: 'Witness our vows in an intimate ceremony overlooking the Adriatic Sea.',
          location: 'Ceremony Garden'
        },
        event4: {
          title: 'Aperitif',
          description: 'Celebrate with champagne and canapés while enjoying the sunset.',
          location: 'Dinner Area'
        },
        event5: {
          title: 'Dinner',
          description: 'A multi-course dinner featuring the finest local cuisine.',
          location: 'Dinner Area'
        },
        event6: {
          title: 'Cake',
          description: 'Join us for the cutting of our wedding cake.',
          location: 'Dinner Area'
        },
        event7: {
          title: 'Afterparty',
          description: 'Dance the night away under the Montenegro sky.',
          location: 'Dinner Area'
        }
      },
      day3: {
        event1: {
          title: 'Pool Party and Pizza',
          description: 'Join us for a relaxed pool party with delicious pizza to close our celebration.',
          location: 'Talici Hill Pool Area'
        }
      }
    },
    dressCode: {
      title: 'What to Wear',
      intro: 'We are so excited to celebrate our wedding with you! As we get closer to the big day, we wanted to share a few details to help you pack and prepare for our weekend in Montenegro.',
      sunday: 'Sunday, September 6th: Welcome Dinner',
      sundayDesc: 'We\'ll kick things off with a relaxed BBQ dinner.',
      sundayCode: 'Dress Code: Smart-Casual/Casual',
      monday: 'Monday, September 7th: The Wedding Day',
      mondayDesc: 'Our ceremony will take place against the backdrop of the Mediterranean and the Montenegrin mountains.',
      mondayCode: 'Dress Code: Summer Outdoor Black Tie',
      mondayNote: '(We want you to dress up and have fun with it!)',
      ladies: 'Ladies:',
      ladiesDesc: 'We are keeping the elegant evening vibe, but the strict floor-length rule is waived! Please opt for elegant fabrics with hemlines falling anywhere from mid-calf to the floor (colourful dresses are still highly encouraged!). Finish off your look with your favorite heels or dressy sandals.',
      gentlemen: 'Gentlemen:',
      gentlemenDesc: 'A black tuxedo (or a traditional kilt where appropriate) is highly preferred. However, if these are unavailable, a black suit is an acceptable alternative. You are welcome to complete the look with a bow tie (preferred) or opt for an open-collar style.',
      tuxedoNote: '* Note: If you need a tuxedo, there are rental options available at reasonable prices.',
      tuesday: 'Tuesday, September 8th: Farewell Brunch & Poolside',
      tuesdayDesc: 'Beach party, casual or light clothing. Don\'t forget your swimsuit so we can make the most of the pool if the sun is shining!',
      tuesdayCode: 'Dress Code: Casual/Beachwear',
      viewGallery: 'View Dress Code Inspiration Gallery →',
      galleryNote: 'Check out our curated collection of outfit ideas and styling inspiration',
      closing: 'We can\'t wait to see you all soon! Please reach out if you have any questions.',
      detailTitle: 'Dear Guests! 🤍',
      detailIntro: 'We have received quite a few questions regarding the dress code, so we wanted to clear everything up and make it super easy for you to plan your outfits for our special day!',
      detailTheme: 'Our theme is a Summer-Chic Black Tie. Since it is summertime, we have relaxed the strict traditional rules for everyone! However, please remember your most important assignment for the evening: to look absolutely stunning, glamorous, and outshine everyone around you! 😉',
      detailGuidelines: 'To help you put your looks together, here are our simple guidelines:',
      detailColorPalette: '✨ Color Palette: We welcome absolutely any colors and shades — from soft pastels to vibrant, juicy summer tones. Even a bright red dress is absolutely allowed and encouraged! We only kindly ask the ladies to avoid two specific colors: white (reserved for the bride) and black (let\'s keep our summer colorful and cheerful!). This rule applies to ladies only.',
      detailLadies: '👗 For Ladies: The strict requirement for "strictly floor-length" gowns is waived, but we are definitely keeping the evening vibe. The length of your dress should be from the mid-calf down to the floor. Opt for elegant fabrics. And, of course, don\'t forget your favorite heels or dressy sandals.',
      detailGentlemen: '👔 For Gentlemen: We have dialed down the strictness for the men as well! A classic tuxedo or simply a highly elegant black suit with a white dress shirt is the perfect choice. A bowtie or a classic tie is optional this time, but we would be very, VERY happy to see them! Let\'s bring that special touch of elegance together. 🤍',
      detailFlexibility: 'Of course, if you still have any questions or find it absolutely impossible to match the dress code perfectly — please don\'t worry, no one is going to turn you away! The most important thing for us is to have you there with us, your smiles, your radiant energy, and your comfort.',
      detailClosing: 'We cannot wait to celebrate with you!'
    },
    weather: {
      title: 'Expected Weather',
      subtitle: 'September in Montenegro'
    },
    venue: {
      title: 'Venue Location',
      getDirections: 'Get Directions',
      visitWebsite: 'Visit Venue Website'
    }
  },
  gallery: {
    title: 'Gallery',
    subtitle: 'Talici Hill, Montenegro',
    dressCode: 'Dress Code Inspiration',
    dressCodeSubtitle: 'Get inspired for our Summer Outdoor Black Tie celebration'
  },
  whatsapp: {
    joinChannel: 'Join our WhatsApp channel for all updates',
    joinGroup: 'Join our WhatsApp group'
  },
  travel: {
    title: 'Travel & Accommodation',
    subtitle: 'Everything you need to know about getting to Montenegro',
    accommodation: {
      title: 'Where to Stay',
      recommendation: 'Accommodation Options',
      description: 'There are many great accommodation options near Talici Hill, including hotels and apartments (such as Apartments Villa Mare Mar) or rental villas.',
      groupTip: 'Pro Tip: Consider Sharing a Villa',
      groupDescription: 'If you choose to rent a villa, consider coordinating with other guests to share a larger property with 4-5 bedrooms. You\'ll get more space, a private pool, and a better experience overall.',
      whatsappPrompt: 'Use our WhatsApp channel to connect with other guests and organize accommodation!'
    },
    gettingThere: {
      title: 'Getting There',
      airport: 'Nearest Airports',
      airportTivat: 'Tivat Airport (TIV)',
      airportPodgorica: 'Podgorica Airport (TGD)',
      airportDubrovnik: 'Dubrovnik Airport (DBV, Croatia)',
      transport: 'Transportation Options',
      carRental: 'Car Rental - Recommended for flexibility',
      taxi: 'Taxi/Transfer - Available from all airports',
      rideshare: 'Ride-sharing apps available in Montenegro'
    },
    localInfo: {
      title: 'Local Information',
      currency: 'Currency: Euro (€)',
      language: 'Language: Montenegrin (English widely spoken in tourist areas)',
      weather: 'Weather in September: Warm and sunny, 20-28°C (68-82°F)',
      whatToPack: 'What to Pack: Swimwear, sunscreen, comfortable shoes, and your dancing outfit!'
    }
  },
  travelForm: {
    title: 'Travel & Guest Details',
    intro1: 'Dear Guests,',
    intro2: 'We kindly ask you to answer a few questions below so we can make your stay at our wedding in Montenegro as comfortable and enjoyable as possible.',
    intro3: 'Thank you for taking a few minutes to complete this form. We can\'t wait to celebrate with you!',
    person: 'Guest',
    selectName: 'Your name',
    selectNamePlaceholder: 'Choose your name from the guest list...',
    selectNameNote: 'Can\'t find your name? Please contact us.',
    personalInfo: 'Personal Information',
    phone: 'Contact number (Telegram / WhatsApp)',
    travelDetails: 'Flight & travel',
    travelModeQ: 'How are you arriving?',
    travelModeFlight: 'Flight',
    travelModeOther: 'Other (car, train...)',
    arrivalDay: 'Arrival day',
    airport: 'Airport',
    airportTivat: 'Tivat',
    airportPodgorica: 'Podgorica',
    airportOther: 'Other',
    airportOtherPlaceholder: 'Please specify the airport',
    arrival: 'Arrival',
    departure: 'Departure',
    date: 'Date',
    pickDate: 'Pick a date',
    time: 'Time',
    flight: 'Airline & flight number',
    flightPlaceholder: 'e.g. Air Serbia JU662',
    transferArrivalQ: 'Do you need a transfer airport → hotel on arrival?',
    transferDepartureQ: 'Do you need a transfer hotel → airport on departure?',
    transferYes: 'Yes',
    transferNo: 'No, I\'ll arrange my own',
    transferOther: 'Other',
    transferOtherPlaceholder: 'Please specify',
    accommodation: 'Accommodation',
    hotelQ: 'Which hotel are you staying at?',
    hotelPlaceholder: 'Hotel name',
    menuTitle: 'Menu · September 7',
    coldAppetizerQ: 'Cold appetizer',
    coldMontenegrin: 'Traditional Montenegrin dish (Njeguški prosciutto, homemade cheese, smoked cheese, cheese with herbs, olives)',
    coldSalmon: 'Salmon tartare with avocado and pickled kohlrabi',
    coldVegan: 'Vegan option: Quinoa salad with dried tomatoes, avocado and sunflower seeds',
    mainCourseQ: 'Main course',
    mainMonkfish: 'Monkfish with saffron risotto and fresh sprouts',
    mainBeef: 'Beef medallions with sautéed vegetables and celery purée',
    mainVegan: 'Vegan option: Grilled tofu with vegetables and fig sauce',
    allergiesQ: 'Allergies or dietary restrictions',
    allergyLactose: 'Lactose',
    allergyGluten: 'Gluten',
    allergyCitrus: 'Citrus',
    allergyNuts: 'Nuts',
    allergyRedFruits: 'Red fruits and vegetables',
    allergyOther: 'Other',
    allergyOtherPlaceholder: 'Please specify',
    flowerAllergyNote: '* If you have a flower allergy, please let us know as well.',
    drinksTitle: 'Drinks',
    drinksQ: 'Drink preferences',
    drinkWhiteWine: 'White wine',
    drinkRedWine: 'Red wine',
    drinkRose: 'Rosé',
    drinkSparkling: 'Sparkling wine',
    drinkBeer: 'Beer',
    drinkRakija: 'Local rakija',
    drinkVodka: 'Vodka',
    drinkGin: 'Gin',
    drinkWhisky: 'Whiskey',
    drinkRum: 'Rum',
    drinkTequila: 'Tequila',
    childrenTitle: 'Families with Children',
    childQ: 'Will you be travelling with a child? If yes, please let us know if there is anything we can do to make your stay more comfortable.',
    childPlaceholder: 'Your answer (optional)',
    beautyTitle: 'Beauty Services',
    beautyQ: 'Stylists will be at the hotel on the wedding day — would you like:',
    beautyMakeup: 'Makeup — price TBC',
    beautyHair: 'Hairstyling — price TBC',
    beautyFullLook: 'Full look (makeup + hairstyling) — price TBC',
    beautyNone: 'No, thank you',
    anythingElse: 'Anything Else?',
    commentsQ: 'Anything else? Questions, requests, comments',
    commentsPlaceholder: 'Your answer (optional)',
    addPerson: '+ Add Another Guest',
    addPersonNote: 'Filling this form for family or friends? Add them here.',
    removePerson: 'Remove',
    whoSection: 'Select guests',
    addChild: '+ Add a Child',
    addChildNote: 'Children have their own menu.',
    childLabel: 'Child',
    childName: 'Child\'s name and surname',
    childNamePlaceholder: 'e.g. Anna Smith',
    sameTravel: 'Same travel details as',
    detailsFor: 'Details for',
    flightFor: 'Flight & travel for',
    kidsMenuTitle: 'Kids menu · September 7',
    kidsAppetizerQ: 'Appetizer',
    kidsAppPastaCheese: 'Pasta with cheese',
    kidsAppPastaNapolitan: 'Pasta Napolitan',
    kidsAppMozzarella: 'Crispy mozzarella sticks',
    kidsMainQ: 'Main course',
    kidsMainNuggets: 'Chicken nuggets with french fries',
    kidsMainChicken: 'Chicken fillet with mashed potatoes',
    kidsMainBurger: 'Burger with fries',
    submit: 'Submit',
    submitting: 'Submitting...',
    errorSelectName: 'Please select a name for each guest',
    errorChildName: 'Please enter the child\'s name',
    errorRequired: 'Please complete all required fields for',
    thankYou: 'Thank You!',
    successMessage: 'Your travel details have been submitted successfully. We can\'t wait to celebrate with you!',
    allSubmitted: 'It looks like everyone has already submitted their travel details. Thank you!',
    alreadySubmittedTag: 'form already submitted',
    alreadySubmittedTitle: 'Travel form already submitted',
    alreadySubmittedIntro: 'We have already received a travel form for',
    alreadySubmittedContact: 'If you need to update or change anything, please contact Polina or Evgeniy directly and we will be happy to help.',
    alreadySubmittedOk: 'Got it',
    loadError: 'Failed to load the guest list. Please refresh the page.'
  }
};
